var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-radio-button d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"my-radio-button-bg",class:{ 'active' : _vm.active }})])
}
var staticRenderFns = []

export { render, staticRenderFns }